let appState = {
    filtersOpen: false
};

const subscribers = [];

const subscribeAppState = (subscriber) => {
    if(subscribers.indexOf(subscriber) === -1){
        subscribers.push(subscriber);
        _publish();
        return _unsubscribe;
    }
}

const setAppState = (params) => {
    appState = Object.assign(appState, params);
    _publish();
}

const _unsubscribe = (subscriber) => {
    subscribers.splice(subscribers.indexOf(subscriber), 1);
}

const _publish = () => {
    subscribers.map(subscriber => {
        return subscriber(appState);
    });
}

export { subscribeAppState, setAppState }